import { useEffect, useState } from "react";
import { parseHashRoute } from "../lib/navigation";

export function useHashRoute() {
  const [route, setRoute] = useState(() =>
    parseHashRoute(window.location.hash),
  );

  useEffect(() => {
    const onHashChange = () => setRoute(parseHashRoute(window.location.hash));
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return route;
}

